<template lang="">
    <div>
        <p>Badge</p>
        <div class="badges">
            <img v-for="a of achievementsCompleted" :src="a.attributes.media.data.attributes.formats.thumbnail.url" alt="" :key="a.id" />
           
        </div>
    </div>
</template>
<script>
export default {
  computed: {
    achievementsCompleted() {
      let achieved = this.$store.getters["profile/achieved"].map((a) => a.achievement.id);
      return this.$store.getters["achievements/achievements"].filter((a) =>
        achieved.includes(a.id)
      );
    },
  },
};
</script>
<style scoped lang="scss">
.badges {
  img {
    width: 60px;
    height: 60px;
    margin: 8px;
  }
}
</style>